import { inject, Injectable } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { InjectableSuperclass } from '@sama/ng-core';
import { combineLatest, filter } from 'rxjs';
import { assertDefined } from '../../../cross-team-shared/misc-utils/strict-record';
import { CalibrationService } from '../../misc-services/calibration.service';
import {
  ProjectionCamera,
  updateProjectionCamera,
} from '../../renderers/projection/projection-camera';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';
import { RendererLayer, setRendererLayers } from '../render-utils';

@Injectable()
export class ProjectionCamerasService extends InjectableSuperclass {
  private readonly store = inject(PointCloudContentStore);
  private readonly calibrationService = inject(CalibrationService);

  cameras: StrictRecord<string, ProjectionCamera> = {};

  getCamera(outputName: string) {
    const camera = this.cameras[outputName];
    assertDefined(camera);
    return camera;
  }

  addCamera(outputName: string) {
    const camera = new ProjectionCamera();
    setRendererLayers([RendererLayer.Projection], camera);
    this.cameras[outputName] = camera;
    this.subscribeToCalibrationData(outputName);
  }

  private subscribeToCalibrationData(videoOutputName: string) {
    this.subscribeTo(
      combineLatest([
        this.store('projectionImageSize')(videoOutputName).$.pipe(
          filter(isDefined),
        ),
        this.calibrationService.getCameraData$(videoOutputName),
      ]),
      ([imageSize, calibrationData]) => {
        const camera = this.getCamera(videoOutputName);
        updateProjectionCamera(camera, calibrationData, imageSize);
      },
    );
  }
}
